import React, {useEffect, useRef, useState} from "react";
import "../scss/colorpicker.scss";
import {CustomPicker} from "react-color";
import {Saturation, Hue} from "react-color/lib/components/common";
import {Button, Input} from "uikit";

const PRESET_COLORS = ['#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4caf50', '#8bc34a', '#cddc39', '#ffeb3b', '#ffc107', '#ff9800', '#ff5722', '#795548', '#607d8b', '#969696', '#000000', '#ffffff']


const ColorPicker = (props) => {
    const pickerRef = useRef(null);
    const [color, setColor] = useState(props.color || "#d9d9d9");

    useEffect(() => {
        setColor(props.color);
    }, [props.color]);

    useEffect(() => {
        pickerRef.current?.focus();
    }, []);

    const handleInputChange = (e) => {
        let newColor = e.target.value;
        setColor(newColor);
        props.onChange({hex: newColor});
    };

    const handleMouseDown = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleSwatchesClick = (e) => {
        e.stopPropagation();
    };

    const handleClickOutside = (e) => {
        if (pickerRef.current && !pickerRef.current.contains(e.target)) {
            props.closeOnBlur();
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div
            ref={pickerRef}
            tabIndex={0}
            className="colorpicker"
        >
            <div className="colorpicker__saturation">
                <Saturation {...props} onChange={props.onChange} onMouseDown={handleMouseDown}/>
            </div>

            <div className="colorpicker__hue">
                <Hue {...props} onChange={props.onChange} direction="horizontal" onMouseDown={handleMouseDown}/>
            </div>

            <div className="colorpicker__preview">
                <div className="colorpicker__preview-box" style={{backgroundColor: color}}/>
            </div>

            <div className="colorpicker__swatches">
                {PRESET_COLORS.map((preset) => (
                    <button
                        key={preset}
                        className="colorpicker__item"
                        style={{backgroundColor: preset}}
                        onClick={() => {
                            setColor(preset);
                            props.onChange({hex: preset});
                        }}
                        onMouseDown={handleSwatchesClick}
                    />
                ))}
            </div>

            <Input
                size={'small'}
                value={color}
                onChange={handleInputChange}
                onMouseDown={(e) => e.stopPropagation()}
            />

            <div className="colorpicker__controls">
                <Button size="xsmall"
                        type="primary"
                        theme="default"
                        onClick={props.closeOnBlur}>
                    Закрыть
                </Button>
                {props.onDelete && (
                    <Button size="xsmall"
                            type="danger"
                            theme="default"
                            onClick={props.onDelete}>
                        Удалить
                    </Button>
                )}
            </div>
        </div>
    );
};

export default CustomPicker(ColorPicker);
